import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import * as React from 'react';
import styled from 'styled-components';
import { alertColors } from '../../styles/colors/colors.js';
import { spacing1x, spacing2x } from '../../styles/spacing.js';
import { Box } from '../Box/Box.js';
import { IconStatusCheck } from '../Icons/IconStatusCheck.js';
import { IconStatusInformation } from '../Icons/IconStatusInformation.js';
import { IconStatusUrgent } from '../Icons/IconStatusUrgent.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var _excluded = ["children", "type", "variant", "style"];
var alertColorMap = {
  error: alertColors.error,
  info: alertColors.information,
  success: alertColors.success,
  warning: alertColors.warning
};
var iconMap = {
  error: IconStatusUrgent,
  info: IconStatusInformation,
  success: IconStatusCheck,
  warning: IconStatusUrgent
};
var roleMap = {
  error: "alert",
  info: "status",
  success: "status",
  warning: "alert"
};
var alertBorderWidth = spacing2x;
var Border = styled.div.withConfig({
  displayName: "Alert__Border",
  componentId: "igw24h-0"
})(["&&{border-top-left-radius:", ";border-bottom-left-radius:", ";border-left:", ";}"], spacing1x, spacing1x, function (_ref) {
  var variant = _ref.variant;
  return "".concat(alertBorderWidth, " solid ").concat(alertColorMap[variant]);
});
var IconWrapper = styled.div.withConfig({
  displayName: "Alert__IconWrapper",
  componentId: "igw24h-1"
})(["&&{color:", ";padding-right:", ";}"], function (_ref2) {
  var variant = _ref2.variant;
  return alertColorMap[variant];
}, spacing2x);
var StyledAlert = styled(Box).withConfig({
  displayName: "Alert__StyledAlert",
  componentId: "igw24h-2"
})(["&&{border-left:0;border-top-right-radius:", ";border-bottom-right-radius:", ";}"], spacing1x, spacing1x);
var Alert = /*#__PURE__*/React.forwardRef(function Alert2(props, ref) {
  var children = props.children,
      type = props.type,
      variant = props.variant,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      rest = _objectWithoutProperties(props, _excluded);

  var Icon = iconMap[variant];
  return /*#__PURE__*/jsx(Border, {
    variant: variant,
    style: style,
    children: /*#__PURE__*/jsxs(StyledAlert, _objectSpread(_objectSpread({}, rest), {}, {
      elevation: type === "toast" ? 4 : void 0,
      padding: type === "toast" ? 4 : void 0,
      ref: ref,
      children: [/*#__PURE__*/jsx(IconWrapper, {
        variant: variant,
        children: /*#__PURE__*/jsx(Icon, {})
      }), children]
    }))
  });
});
Alert.propTypes = {
  "children": _PropTypes.node,
  "style": _PropTypes.object,
  "type": _PropTypes.oneOf(["banner", "toast"]).isRequired,
  "variant": _PropTypes.oneOf(["error", "info", "success", "warning"]).isRequired
};
Alert.displayName = "Alert";

export { Alert, alertBorderWidth, roleMap };
